// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jVjs","largestCol":"styles_largestCol__G-eeD","smallestCol":"styles_smallestCol__3jUio"};